import { useRef, useCallback } from 'react';
import createStageHandlersRegistry from '../helpers/create-stage-handlers-registry';
import runStageHandlers from '../helpers/run-stage-handlers';

const useStageHandlers = (initialData = null) => {
  const registry = useRef(createStageHandlersRegistry(initialData?.stageHandlers));

  const registerStageHandlers = useCallback((chunkId, stageHandlersConfig) => {
    registry.current.registerStageHandlersForChunk(chunkId, stageHandlersConfig);
  }, []);

  const unregisterStageHandlers = useCallback((chunkId) => {
    registry.current.unregisterStageHandlersForChunk(chunkId);
  }, []);

  const runStage = useCallback(async (options) => {
    const handlers = registry.current.getHandlersByStage(options.stage);

    if (handlers.length === 0) {
      return { flowData: options.flowData || {} };
    }

    const flowData = await runStageHandlers(handlers, options);

    return { flowData };
  }, []);

  const getPersistData = useCallback(
    () => ({
      stageHandlers: registry.current.getStageHandlers(),
    }),
    []
  );

  return {
    registerStageHandlers,
    unregisterStageHandlers,
    runStage,
    getPersistData,
  };
};

export default useStageHandlers;
